// HEAL-46b §9.4 / HEAL-76 §4.1 — куда ведёт уведомление.
//
// Отдельным модулем от push.ts намеренно: там нативный плагин, который на web не
// резолвится, а это — чистая функция, и проверять её надо обычным тестом.
//
// Адрес назначения считает сервер и кладёт в данные уведомления; клиент только
// исполняет. Текстов, чисел и названий показателей в данных нет и быть не должно
// (D-22): всё содержательное человек видит уже внутри приложения.
//
// HEAL-76: два слоя вместо одного. Ядро принимает типизированную запись ленты,
// адаптер разбирает строковый словарь FCM и зовёт ядро. Обе стороны ходят одной
// дорогой (I-5) — иначе тап по уведомлению и тап по строке в ленте однажды
// приведут в разные места.

export type PushTarget = string | null;

export type NotificationTarget = {
  type: string;
  target?: string | null;
  targetId?: number | null;
};

/** Ядро: решает, куда вести. Общее для push и для ленты. */
export function targetPath({ type, target, targetId }: NotificationTarget): PushTarget {
  // У рассылки цели нет: тап открывает приложение, строка в ленте не кликабельна.
  if (type === 'broadcast') return null;

  if (type !== 'uploads_finished') return null;

  if (target === 'batch' && Number.isInteger(targetId) && (targetId as number) > 0) {
    return `/uploads/batch/${targetId}`;
  }

  // Всё остальное — в «Мои загрузки»: там виден любой исход, включая причину
  // отказа. Экран проверки открывать нельзя, файл мог и не распознаться.
  //
  // Сюда же попадает удалённый пакет: сервер подменяет цель при выдаче ленты
  // (D-5), потому что проверить существование пакета клиент не может.
  return '/uploads';
}

/** Адаптер данных FCM: они приходят строками, числами не остаются. */
export function targetPathFromPayload(data: unknown): PushTarget {
  if (!data || typeof data !== 'object') return null;

  const payload = data as Record<string, unknown>;

  const rawId = payload.batch_id;
  const targetId = typeof rawId === 'string' || typeof rawId === 'number' ? Number(rawId) : null;

  return targetPath({
    type: typeof payload.type === 'string' ? payload.type : '',
    target: typeof payload.target === 'string' ? payload.target : null,
    targetId: Number.isInteger(targetId) ? targetId : null,
  });
}
